import { useLocation,Navigate } from 'react-router-dom';
import AuthContext from '../contexts/auth';
import { useContext} from 'react';

export const NotLoggedRoute = ({ children }) => {
  console.log('not logged guard');
  const location = useLocation();
  const authContext = useContext(AuthContext);
  const isAuthenticated = authContext.isLoggedIn;
  if (isAuthenticated) {
    // user is not authenticated
    return <Navigate to="/home" state={{ from: location }} replace />;
  }
  return children;
};
